module.exports = __webpack_public_path__ + "static/PP0-cbfdf05de0012942456c64d24c9f3a6e.jpg";